export class MonthlyData{
    public workingYm: string
    public empCd: string
    public empNm: string
    public divisionCd: string
    public divisionNm: string
    public divisionSNm: string
    public monthlyStatus: string
    public monthlyStatusNm: string
    public busCommuteFlg: boolean
    public warningKbn: string
    public decisionRemarks:string
    public approvalDate1st: Date
    public approvalEmpCd1st: string
    public approvalEmpNm1st: string
    public approvalDate2nd: Date
    public approvalEmpCd2nd: string
    public approvalEmpNm2nd: string
    public approvalDate3rd: Date
    public approvalEmpCd3rd: string
    public approvalEmpNm3rd: string
    public confirmDate1st: Date
    public confirmEmpCd1st: string
    public confirmEmpNm1st: string
    public confirmDate2nd: Date
    public confirmEmpCd2nd: string
    public confirmEmpNm2nd: string
    public confirmDate3rd: Date
    public confirmEmpCd3rd: string
    public confirmEmpNm3rd: string
    public renewDate :Date
}
